import './css';
import components from './components';
import { disableAutoCompleteMixin } from './mixin';

export default {
  install(app) {
    components.setup(app);

    app.mixin(disableAutoCompleteMixin);
  },
};

export * from './functions';
